import React, { Component } from 'react'
import GenericModal from './GenericModal'
import { withTranslation } from 'react-i18next';

class PendingRequestDialog extends Component {
  render() {
    const title = this.props.title || this.props.t('PendingRequestDialog.PleaseWait')

    return (
      <GenericModal
        title={title}
        visible={this.props.visible}
        width={380}
        hideCloseButton
      />
    )
  }
}

export default withTranslation('translations')(PendingRequestDialog)
